import { __assign } from "tslib";
import * as React from 'react';
var SvgArrowRight = function (props) { return (React.createElement("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24" }, props),
    React.createElement("g", { fill: "none", fillRule: "evenodd" },
        React.createElement("path", { d: "M0 0h24v24H0z" }),
        React.createElement("path", { fill: "#6A6E72", d: "M9.429 17.188a.625.625 0 1 0 .883.883l5.442-5.442-5.442-5.441a.625.625 0 1 0-.883.883l4.558 4.558-4.558 4.559z" })))); };
export default SvgArrowRight;
//# sourceMappingURL=ArrowRight.js.map